import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import FirstScreen        from './FirstScreen/FirstScreen';
import Login              from './FirstScreen/Login';
import SignupPage         from './FirstScreen/Signuppage';
import ForgotPassword     from './FirstScreen/Forgotpassword';
import Dashboard          from './FirstScreen/Dashboard';
import BusinessOnboarding from './FirstScreen/Businessonboarding';
import ClientOnboarding   from './FirstScreen/ClientOnboarding';
import AdminLogin         from './SuperAdmin/AdminLogin';
import AdminDashboard     from './SuperAdmin/AdminDashboard';

const API = "https://canada-billing.ameontech.com";

// Super Admin has its own separate auth (adminToken), set by
// AdminLogin hitting the admin login API — independent of the
// regular user token used by ProtectedDashboard below.
function AdminGuard({ children }) {
  const adminToken = localStorage.getItem("adminToken");
  if (!adminToken) return <Navigate to="/superadmin" replace />;
  return children;
}

function OnboardingRoute() {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return (
    <BusinessOnboarding
      onComplete={() => { window.location.href = "/client-setup"; }}
      onSkip={()    => { window.location.href = "/dashboard"; }}
    />
  );
}

function ClientSetupRoute() {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return (
    <ClientOnboarding
      onComplete={() => { window.location.href = "/dashboard"; }}
      onSkip={()    => { window.location.href = "/dashboard"; }}
    />
  );
}

function ProtectedDashboard() {
  const token = localStorage.getItem("token");
  const [loading, setLoading]               = React.useState(true);
  const [onboardingDone, setOnboardingDone] = React.useState(false);

  React.useEffect(() => {
    if (!token) { setLoading(false); return; }
    fetch(`${API}/api/business-profile`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        if (data?.profile?.business_name) setOnboardingDone(true);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (!token)          return <Navigate to="/login"      replace />;
  if (loading)         return null;
  if (!onboardingDone) return <Navigate to="/onboarding" replace />;
  return <Dashboard />;
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"                    element={<FirstScreen />} />
        <Route path="/login"               element={<Login />} />
        <Route path="/signup"              element={<SignupPage />} />
        <Route path="/forgot-password"     element={<ForgotPassword />} />
        <Route path="/onboarding"          element={<OnboardingRoute />} />
        <Route path="/client-setup"        element={<ClientSetupRoute />} />
        <Route path="/dashboard"           element={<ProtectedDashboard />} />

        {/* Super Admin */}
        <Route path="/superadmin" element={<AdminLogin />} />
        <Route
          path="/superadmin/dashboard"
          element={
            <AdminGuard>
              <AdminDashboard />
            </AdminGuard>
          }
        />
      </Routes>
    </Router>
  );
}